import styled from 'styled-components';

import colors from 'app/styles/theme/colors';
import typography from 'app/styles/theme/typography';
import { fontSizes } from 'app/styles/theme/sizes';

const { gray, red } = colors.designSystem;

// Overlay, largura, fundo, cantos e scroll vêm do ModalDialog (MUI Dialog).
export const Card = styled.div`
  position: relative;
  font-family: ${typography.quartenary};
`;

export const Illustration = styled.img`
  display: block;
  width: 100%;
  height: auto;
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 11px;
  right: 11px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: transparent;
  color: ${gray[950]};
  font-family: inherit;
  font-size: ${fontSizes.xxl};
  line-height: 1;
  cursor: pointer;

  &:hover,
  &:focus-visible {
    background: ${gray[200]};
  }
`;

export const Body = styled.div<{ $align: 'left' | 'center' }>`
  padding: 20px 48px 40px;
  text-align: ${({ $align }) => $align};

  @media (max-width: 480px) {
    padding: 20px 24px 32px;
  }
`;

export const Title = styled.strong`
  display: block;
  color: ${gray[950]};
  font-size: ${fontSizes.xl};
  font-weight: 700;
  line-height: 1.4;
`;

export const Description = styled.p`
  margin: 4px 0 0;
  color: ${gray[950]};
  font-size: ${fontSizes.sm};
  line-height: 1.4;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 24px;
  text-align: left;
`;

export const FieldsRow = styled.div`
  display: flex;
  gap: 16px;

  @media (max-width: 480px) {
    flex-direction: column;
  }
`;

export const NumberField = styled.div`
  flex: 1 1 auto;
  min-width: 0;
`;

export const StateField = styled.div`
  flex: 0 0 108px;

  @media (max-width: 480px) {
    flex: 1 1 auto;
  }
`;

export const ErrorMessage = styled.span`
  color: ${red[500]};
  font-size: ${fontSizes.sm};
  line-height: 1.4;
`;

export const Actions = styled.div`
  margin-top: 8px;
`;

export const SuccessActions = styled.div`
  margin-top: 32px;
`;
